import * as React from 'react';
import styled from "styled-components";
import Dropzone, {FileWithPreview} from "react-dropzone";
import {ConstBorderRound, ConstColor, ConstHeight} from "../../../../config/styles_const/styles_const";
import Paragraph from "../text/paragraph";

import {frontEndConfig} from "../../../../config/config";

const uploadFileMaxSize = frontEndConfig.uploadFileMaxSize;

interface IProps {
    name: string
    handleOnDrop: (acceptedFiles: FileWithPreview[], rejectedFiles: FileWithPreview[]) => void;
    updateThumbnailURL: string | null;
    thumbnailURL: string;
}

const StyledThumbnailDropZone: React.FC<IProps> = (props) => {

    const {name, handleOnDrop, updateThumbnailURL, thumbnailURL} = props;

    return(
        <StyledDropZoneDefalt
            name={name}
            onDrop={handleOnDrop}
            accept="image/jpeg, image/png"
            disablePreview={false}
            multiple={false}
            maxSize={uploadFileMaxSize}
        >
            <DropZoneTxtWrapper>
                <DropZoneTxt >カバー画像を設定</DropZoneTxt>
            </DropZoneTxtWrapper>
            {(updateThumbnailURL) ? (
                <ThumbnailDropzoneImg key={updateThumbnailURL} src={updateThumbnailURL}/>
            ) : ( thumbnailURL ? <ThumbnailDropzoneImg key={thumbnailURL} src={thumbnailURL}/> : <div/> )
            }
        </StyledDropZoneDefalt>

    )
};

export default StyledThumbnailDropZone

const StyledDropZoneDefalt = styled(Dropzone)`
    position: relative;
    height: ${ConstHeight.ProjectThumbnail};
    width: 100%;
    margin: 40px auto 35px auto;
    &:hover {
        cursor: pointer;
    }
    border-radius: ${ConstBorderRound.CornerRoundAll};
`;

const DropZoneTxtWrapper = styled.div`
    position: absolute;
    background-color: rgba(0,0,0,.7);
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin:0;
    padding:0;
    text-align: center;
    border-radius: ${ConstBorderRound.CornerRoundAll};
`;

const DropZoneTxt = styled(Paragraph)`
    color: ${ConstColor.White};
`;

const ThumbnailDropzoneImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: ${ConstBorderRound.CornerRoundAll};
`;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/drop_zone/styled_thumbnail_drop_zone.tsx